/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import Timer from 'src/components/Counter';
import Loading from 'src/components/Loading';
import PorcentajeCompra from 'src/components/PorcentajeCompra';
import VerificationToken from 'src/components/VerificationToken';
import withCotizacion from 'src/HOC/withCotizacion';
import {
  asyncGetTokenCot,
  asyncVerificarTokenCot,
} from 'src/reducers/Cotizacion/cotizacion.actions';
import { guardarLead } from 'src/services';
import { maskCellNumber, maskEmailAddress } from 'src/utils/functiones';

const VerificarTokenPago = ({
  cotizacion,
  dispatch,
  fetchGetToken,
  fetchVerificarToken,
  history,
  dataGetToken,
  dataVerificarToken,
  idCotizacion,
}) => {
  const [alert, setAlert] = useState({ show: false, message: '' });
  const [timeFinished, setTimeFinished] = useState(false);

  const tokenLength = 6;
  const enviarToken = useCallback(
    (event) => {
      setTimeFinished(false);
      dispatch(asyncGetTokenCot());
    },
    [dispatch],
  );

  useEffect(() => {
    guardarLead(idCotizacion, `VERIFICAR_TOKEN_PAGO__INGRESO`);
    enviarToken();
  }, [enviarToken]);

  useEffect(() => {
    if (dataVerificarToken) {
      if (dataVerificarToken.transaccion) {
        guardarLead(idCotizacion, `VERIFICAR_TOKEN_PAGO__TOKEN_CORRECTO`);

        // history.push(`/newFinCompra/${idCotizacion}`);
        history.push(`/ingresarPoliza/${idCotizacion}/`);
      } else {
        guardarLead(idCotizacion, `VERIFICAR_TOKEN_PAGO__TOKEN_INVALIDO`);
        setAlert({
          show: true,
          message: dataVerificarToken.mensaje,
        });
      }
    }

    if (dataGetToken) {
      if (!dataGetToken.transaccion) {
        guardarLead(idCotizacion, `VERIFICAR_TOKEN_PAGO__ERROR_VERIFICAR_TOKEN`);
        setAlert({ show: true });
      }
    }
  }, [dataVerificarToken, dataGetToken, history, idCotizacion]);

  const onChangeToken = (token) => {
    if (token.length === tokenLength) {
      guardarLead(idCotizacion, `VERIFICAR_TOKEN_PAGO__REGISTRO_TOKEN`);
      dispatch(asyncVerificarTokenCot(token));
    }
  };

  if (fetchGetToken.loading && !fetchGetToken.completed) {
    return (
      <Loading
        principal="Enviando Token"
        secundario={`Se le enviará un token de verificación por favor revisar sus SMS o Email`}
      />
    );
  }

  return (
    <div className="container-fluid">
      <PorcentajeCompra porcentaje={90} />
      <div className="row justify-content-center">
        <div className="col-11 col-sm-8">
          <p className=" text-secondary" style={{ fontSize: '14px' }}>
            Estas a punto de completar la transacción, te hemos enviado un código de verificación al
            correo
            {' ' + maskEmailAddress(cotizacion.titular.email)} o al número{' '}
            {maskCellNumber(cotizacion.titular.celular)} por favor ingresalo aquí, para poder
            procesar tu transacción.
          </p>
        </div>
      </div>
      {console.log("ingresa 1")}
      <div className="row justify-content-center mt-3">
        <div className="col-10 col-sm-8">
          <p className="font-weight-bold text-secondary">
            Tiempo restante{' '}
            <Timer
              initialTime={180000}
              //initialTime={5000}
              direction="backward"
              onFinish={() => setTimeFinished(true)}
            />
          </p>
        </div>
      </div>

      {timeFinished && (
        <div className="row d-flex flex-row py-5">
          {console.log("ingresa 2")}
          <div className="mx-auto">
            <h4 className="text-center text-secondary font-weight-bold">Su token ha expirado</h4>

            <Button size="sm" variant="primary" onClick={enviarToken} block>
              Reenviar Token
            </Button>
          </div>
        </div>
      )}

      {!timeFinished && !fetchVerificarToken.loading && (
        <div className="row d-flex flex-row py-5">
          {console.log("ingresa 3")}
          <div className="mx-auto">
            <VerificationToken
              inputClass="font-weight-bold text-center text-secondary rounded"
              tokenLength={tokenLength}
              onTokenChanged={onChangeToken}
            />
          </div>
        </div>
      )}

      {fetchVerificarToken.loading && !fetchVerificarToken.completed && (
        <div className="row justify-content-center">
          {console.log("ingresa 4")}
          <div className="col-12">
            <Loading
              principal="Verificando Token"
              secundario="Esto puede tardar unos segundos, espere por favor."
              noFullScreen
            />
          </div>
        </div>
      )}

      {alert.show && (
        <Alert
          className="fixed-bottom"
          variant="warning"
          dismissible
          onClose={() => setAlert({ show: false })}
        >
          {alert.message}
        </Alert>
      )}
    </div>
  );
};

export default withCotizacion(VerificarTokenPago);
